function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3715",
  "data-name": "Grupo 3715",
  transform: "translate(1.448 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_12",
  "data-name": "Caminho 12",
  d: "M109.666,248h7.486l5.728,19.595h-5.075l2.462,16.078-10.25-19.7h5.7Z",
  transform: "translate(-109.666 -248)",
  fill: "none",
  stroke: "#fdb83c",
  strokeWidth: 2
}));

var SvgRaioDash = function SvgRaioDash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.996,
    height: 37.134,
    viewBox: "0 0 15.996 37.134",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRaioDash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/RaioDash.7a71655f.svg";
export { ForwardRef as ReactComponent };